import React, { useState, useEffect, useMemo, useRef } from "react";
import {
  Modal,
  Backdrop,
  Fade,
  Box,
  Typography,
  Collapse,
  IconButton,
} from "@material-ui/core";
import { Close as CloseIcon, ExpandMore, ExpandLess } from "@material-ui/icons";
import "./ModalAttribution.css";
import rest from "../../../rest";
import { groupTranchesByDateModal } from "../utils";
import TranchesAccordion from "./TranchesAccordion";
import { MySnackbar } from "../../../components/mySnackbar/MySnackbar";
import { useSelector } from "react-redux";
import ButtonConfirm from "../../../components/general/ButtonConfirm";
import ButtonStyled from "../../../components/general/ButtonStyled";
import useStyles from "./ModalAttributionStyle";

const ModalAttributionTranche = ({
  setReload,
  user,
  open,
  handleClose,
  selectedActivity,
  selectedTranches,
  setSelectedTranches,
  activeStep,
}) => {
  const [tranches, setTranches] = useState([]);
  const [visibleGroups, setVisibleGroups] = useState({});
  const [otherTimes, setOtherTimes] = useState([]);
  const [openAutreHoraire, setOpenAutreHoraire] = useState(false);
  const [snack, setSnack] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);
  const prevSelectedActivityRef = useRef();

  const manifParams = useSelector((state) => state.manif);
  const currentUser = useSelector((state) => state.user);

  const [userTranches, setUserTranches] = useState([]);

  const classes = useStyles()();

  useEffect(() => {
    if (user && user.wish && user.wish.tranches) {
      setUserTranches(user.wish.tranches);
    }
  }, [user]);

  useEffect(() => {
    if (
      selectedActivity &&
      selectedActivity.id &&
      !isLoaded &&
      prevSelectedActivityRef.current !== selectedActivity.id
    ) {
      prevSelectedActivityRef.current = selectedActivity.id;
      rest
        .post("/benevols/attribution/trancheFromActivite.json", {
          idActivite: selectedActivity.id,
        })
        .then((response) => {
          if (response.data.success) {
            setTranches(response.data.tranche);
            // Initialiser visibleGroups avec le premier jour
            const firstDate = Object.keys(
              groupTranchesByDateModal(response.data.tranche)
            )[0];
            setVisibleGroups({ [firstDate]: true });

            setSelectedTranches(() =>
              response.data.tranche.filter((tr) =>
                user.tempo?.some((tmp) => tmp.ID === tr.ID)
              )
            );

            // Filtrer les horaires qui ne sont pas dans userTranches
            const allTranches = response.data.tranche;
            const otherTimes = allTranches.filter((tranche) => {
              return !user.wish.tranches.some(
                (userTranche) => userTranche.ID === tranche.ID
              );
            });
            setOtherTimes(otherTimes);
            setIsLoaded(true);
          }
        })
        .catch((error) => {
          console.error("There was an error fetching the data!", error);
        });
    }
    // eslint-disable-next-line
  }, [selectedActivity, userTranches, user, setSelectedTranches]);

  const groupedTranches = groupTranchesByDateModal(tranches);

  // Filtrer groupedTranches en fonction des tranches de l'utilisateur
  const filteredGroupedTranches = useMemo(() => {
    const result = {};
    Object.keys(groupedTranches).forEach((date) => {
      const filteredTranches = groupedTranches[date].filter((tranche) => {
        return userTranches.some(
          (userTranche) => userTranche.ID === tranche.ID
        );
      });
      if (filteredTranches.length > 0) {
        result[date] = filteredTranches;
      }
    });
    return result;
  }, [groupedTranches, userTranches]);

  const handleCheckboxChange = (tranche) => {
    setSelectedTranches((prevSelected) => {
      if (prevSelected.some((selected) => selected.ID === tranche.ID)) {
        return prevSelected.filter((item) => item.ID !== tranche.ID);
      } else {
        return [...prevSelected, tranche];
      }
    });
  };

  const handleToggleGroup = (date) => {
    setVisibleGroups((prevVisible) => ({
      ...prevVisible,
      [date]: !prevVisible[date],
    }));
  };

  const handleExpand = () => {
    setOpenAutreHoraire(!openAutreHoraire);
  };

  const handleDesistUser = () => {
    rest
      .post("/benevols/attribution/desistement.json", { idUser: user.ID })
      .then((response) => {
        if (response.data.success) {
          setSnack({
            message: "Désistement effectué avec success",
            show: true,
            severity: "success",
          });
          setReload((re) => !re);
        } else
          setSnack({
            message: response.data.message,
            show: true,
            severity: "error",
          });

        setTimeout(() => {
          handleClose();
        }, 1000);
      })
      .catch((error) => {
        setSnack({ message: error, show: true, severity: "error" });
        console.error("There was an error fetching the data!", error);
        handleClose();
      });
  };

  const handleRefuser = () => {
    rest
      .post("/benevols/attribution/refuser.json", {
        idUser: user.ID,
        idActivite: selectedActivity.id,
      })
      .then((response) => {
        console.log(response);
        setReload((re) => !re);
      })
      .catch((error) => {
        console.error("There was an error on refus!", error);
      });
    handleClose();
  };

  const formatTranchesToSend = (statut) => {
    const sendTranchesPerson = selectedTranches.map((item) => {
      return {
        ID_Person: user.ID,
        ID_Tranche: item.ID,
        ID_AjouterPar: currentUser.User.User_ID,
        ID_Manifestation: manifParams.manifInfos.Id,
        Statut: statut,
      };
    });
    return sendTranchesPerson;
  };

  const sendData = (sendTranchesPerson) => {
    rest
      .post("/benevols/attribution/addTranche.json", {
        tranches: sendTranchesPerson,
      })
      .then((response) => {
        setReload((re) => !re);
        handleClose();
      })
      .catch((error) => {
        setSnack({ message: error, show: true, severity: "error" });
      });
  };

  const handlValider = () => {
    if (selectedTranches.length > 0) {
      const sendTranchesPerson = formatTranchesToSend(0); // statut 0 = valider
      sendData(sendTranchesPerson);
    } else {
      setSnack({
        message: "Pas de tranche séléctionnée",
        show: true,
        severity: "error",
      });
    }
  };

  const handlPreValider = () => {
    if (selectedTranches.length > 0) {
      const sendTranchesPerson = formatTranchesToSend(1); // statut 0 = preValider
      sendData(sendTranchesPerson);
    } else {
      setSnack({
        message: "Pas de tranche séléctionnée",
        show: true,
        severity: "error",
      });
    }
  };

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <div className={classes.header}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h6" className={classes.title}>
                {selectedActivity.name
                  ? selectedActivity.name
                  : selectedActivity.nom}
              </Typography>
              <IconButton onClick={handleClose} className={classes.closeButton}>
                <CloseIcon />
              </IconButton>
            </Box>
          </div>
          <div className={classes.content}>
            <MySnackbar params={snack} />
            <Typography
              variant="h1"
              style={{
                marginBottom: 12,
                fontWeight: "bold",
                color: "#333",
                fontSize: "18px",
              }}
            >
              Disponibilités
            </Typography>

            <TranchesAccordion
              groupedTranches={filteredGroupedTranches}
              visibleGroups={visibleGroups}
              handleToggleGroup={handleToggleGroup}
              selectedTranches={selectedTranches}
              handleCheckboxChange={handleCheckboxChange}
              setSelectedTranches={setSelectedTranches}
            />

            {otherTimes.length > 0 && (
              <div style={{ marginTop: "16px" }}>
                <Typography
                  variant="h1"
                  onClick={handleExpand}
                  style={{
                    marginBottom: 12,
                    fontWeight: "bold",
                    color: "#333",
                    fontSize: "18px",
                  }}
                >
                  Ajouter d'autres dates et horaires
                  <IconButton>
                    {openAutreHoraire ? <ExpandLess /> : <ExpandMore />}
                  </IconButton>
                </Typography>

                <Collapse in={openAutreHoraire}>
                  <TranchesAccordion
                    groupedTranches={groupTranchesByDateModal(otherTimes)}
                    visibleGroups={visibleGroups}
                    handleToggleGroup={handleToggleGroup}
                    selectedTranches={selectedTranches}
                    handleCheckboxChange={handleCheckboxChange}
                    setSelectedTranches={setSelectedTranches}
                  />
                </Collapse>
              </div>
            )}

            <Box className={classes.buttonContainer}>
              <ButtonConfirm
                onConfirm={handleDesistUser}
                text="DÉSISTEMENT"
                textConfirm="Confirmer désistement"
                variant="contained"
                color="standardBtn"
                style={{ marginRight: 10 }}
              />
              <ButtonConfirm
                onConfirm={handleRefuser}
                text="REFUSER"
                textConfirm="Confirmer refuser"
                variant="contained"
                color="errorBtn"
                style={{ marginRight: 10 }}
              />
              {activeStep.type === "wish" ? (
                <ButtonStyled
                  variant="contained"
                  color="successLightBtn"
                  onClick={handlPreValider}
                >
                  PRÉ-VALIDER
                </ButtonStyled>
              ) : activeStep.type === "preValider" ? (
                <ButtonStyled
                  variant="contained"
                  color="successDarkBtn"
                  onClick={handlValider}
                >
                  VALIDER
                </ButtonStyled>
              ) : (
                <ButtonStyled
                  variant="contained"
                  color="successDarkBtn"
                  onClick={handlValider}
                >
                  MODIFIER
                </ButtonStyled>
              )}
            </Box>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default ModalAttributionTranche;
